import React from "react";
import _ from "lodash";

const UserSearch = ({ onSearch }) => {
  const handleChange = _.debounce((value) => onSearch(value), 350);

  return (
    <div className="searchbar__wrapper mb--16" style={{ justifyContent: "flex-start" }}>
      <div className="details__header__partition__item">
        <div className="details__header__partition__item__title">Users</div>
        <div className="searchbar__container">
          <div className="searchbar__icon">
            <i className="solid solid-budicon-search-a" />
          </div>
          <input
            className="searchbar__input"
            type="text"
            placeholder="Search"
            onChange={(e) => handleChange(e.target.value)}
          />
        </div>
      </div>
    </div>
  );
};

export default UserSearch;
